import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import CardHeader from "@commons/businesscardHeader";
import Button from "@components/button";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";
import { ButtonContainer } from "./styles";

const SocialMedia = () => {
  const [initialValues, setInitialValues] = useState({
    facebook: "",
    instagram: "",
    twitter: "",
    linkedin: "",
    tiktok: "",
    youtube: "",
  });
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState<any>(null);

  const fetchSocialMedia = async () => {
    try {
      const res = await generalSettings.getByKey({
        state: "social",
        id: "social-media",
      });
      if (res) {
        const parsed = JSON.parse(res.value || "{}");
        setInitialValues({
          facebook: parsed.facebook || "",
          instagram: parsed.instagram || "",
          twitter: parsed.twitter || "",
          linkedin: parsed.linkedin || "",
          tiktok: parsed.tiktok || "",
          youtube: parsed.youtube || "",
        });
        setExist(res);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSocialMedia();
  }, []);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      const payload = {
        key: "social-media",
        group: "social-media-settings",
        value: JSON.stringify(values),
      };

      if (exist?.id) {
        await generalSettings.update({
          state: "social",
          id: exist.id,
          data: payload,
        });
        toast.success("Social media links updated successfully!");
      } else {
        await generalSettings.create({
          state: "social",
          data: payload,
        });
        toast.success("Social media links saved successfully!");
      }

      fetchSocialMedia();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update social media links");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <Form>
          <CardHeader title="Social Media Settings" />
          <Wrapper>
            <Column>
              <Row>
                <Fields.Input
                  name="facebook"
                  placeholder="Enter Facebook link"
                  label="Facebook Link"
                  value={values.facebook}
                />
                <Fields.Input
                  name="instagram"
                  placeholder="Enter Instagram link"
                  label="Instagram Link"
                  value={values.instagram}
                />
              </Row>

              <Row>
                <Fields.Input
                  name="twitter"
                  placeholder="Enter Twitter link"
                  label="Twitter Link"
                  value={values.twitter}
                />
                <Fields.Input
                  name="linkedin"
                  placeholder="Enter LinkedIn link"
                  label="LinkedIn Link"
                  value={values.linkedin}
                />
              </Row>

              <Row>
                <Fields.Input
                  name="tiktok"
                  placeholder="Enter TikTok link"
                  label="TikTok Link"
                  value={values.tiktok}
                />
                <Fields.Input
                  name="youtube"
                  placeholder="Enter YouTube link"
                  label="YouTube Link"
                  value={values.youtube}
                />
              </Row>

              <ButtonContainer>
                <Button
                  title={exist ? "Update" : "Save"}
                  type="submit"
                  loading={loading}
                  justify="end"
                />
              </ButtonContainer>
            </Column>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default SocialMedia;
